/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import { computed } from 'vue';
import '../hooks/index.mjs';
import { usePrefixClass } from '../hooks/useConfig.mjs';
import '../hooks/icon.mjs';
import '../_chunks/dep-97c71289.mjs';
import '../_chunks/dep-6f3e4f56.mjs';
import '../_chunks/dep-b1060562.mjs';
import '../_chunks/dep-b333ab93.mjs';
import '../_chunks/dep-4efc69ee.mjs';
import '../hooks/slot.mjs';
import '../_chunks/dep-0d1bd08c.mjs';
import '../hooks/tnode.mjs';
import '../_chunks/dep-0a6fd248.mjs';
import '../_chunks/dep-7ad89920.mjs';
import '../_chunks/dep-c5d88cfe.mjs';
import '../_chunks/dep-36563716.mjs';
import '../_chunks/dep-8049d2e0.mjs';
import '../_chunks/dep-b1013215.mjs';
import '../_chunks/dep-91fc304f.mjs';
import '../_chunks/dep-17446155.mjs';
import '../_chunks/dep-8747fcf0.mjs';
import '../utils/render-tnode.mjs';
import '../_chunks/dep-ec227f3f.mjs';
import '../_chunks/dep-18bb982b.mjs';
import '../_chunks/dep-25d66c95.mjs';
import '../_chunks/dep-372265bb.mjs';
import '../_chunks/dep-ae08d6c4.mjs';
import '../_chunks/dep-d940e2da.mjs';
import '../_chunks/dep-e50fa7b0.mjs';
import '../_chunks/dep-c57d8117.mjs';
import '../_chunks/dep-c7e4942d.mjs';
import '../_chunks/dep-5f6c8826.mjs';
import '../hooks/useCommonClassName.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-493c38ce.mjs';
import '../_chunks/dep-b56b2dc0.mjs';
import '../_chunks/dep-77f634fb.mjs';
import '../_chunks/dep-28ae3cda.mjs';
import '../_chunks/dep-7211604f.mjs';
import '../_chunks/dep-75df64b1.mjs';
import '../_chunks/dep-48b9a098.mjs';
import '../_chunks/dep-52c1d6a9.mjs';
import '../_chunks/dep-6043e9fc.mjs';
import '../_chunks/dep-3a045465.mjs';
import '../_chunks/dep-53dc0ac1.mjs';
import '../_chunks/dep-b6b4eaa3.mjs';
import '../_chunks/dep-881cffb7.mjs';
import '../_chunks/dep-436b338d.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../_chunks/dep-2d31a683.mjs';
import '../_chunks/dep-3ddc95d0.mjs';
import '../config-provider/type.mjs';
import '../hooks/useDefaultValue.mjs';
import '../hooks/useDestroyOnClose.mjs';
import '../hooks/useKeepAnimation.mjs';
import '../hooks/useRipple.mjs';
import '../utils/set-style.mjs';
import '../hooks/useVirtualScroll.mjs';
import '../_chunks/dep-a26b9c60.mjs';
import '../hooks/useVModel.mjs';
import '../hooks/useImagePreviewUrl.mjs';
import '../_chunks/dep-89b33ff6.mjs';
import '../_chunks/dep-6bcce672.mjs';
import '../_common/js/upload/utils.mjs';
import '../_common/js/log/log.mjs';

var FORM_CONTROL_COMPONENTS = ["TInput", "TInputNumber", "TTextarea", "TCascader", "TSelect", "TOption", "TSwitch", "TCheckbox", "TCheckboxGroup", "TRadio", "TRadioGroup", "TTreeSelect", "TDatePicker", "TTimePicker", "TUpload", "TTransfer", "TSlider"];
var useCLASSNAMES = function useCLASSNAMES() {
  var classPrefix = usePrefixClass();
  return computed(function () {
    var form = "".concat(classPrefix.value, "-form");
    var input = "".concat(classPrefix.value, "-input");
    var is = "".concat(classPrefix.value, "-is");
    return {
      form: form,
      label: "".concat(form, "__label"),
      labelTop: "".concat(form, "__label--top"),
      inline: "".concat(form, "-inline"),
      formItem: "".concat(form, "__item"),
      formItemWithHelp: "".concat(form, "__item-with-help"),
      formItemWithExtra: "".concat(form, "__item-with-extra"),
      controls: "".concat(form, "__controls"),
      controlsContent: "".concat(form, "__controls-content"),
      status: "".concat(form, "__status"),
      extra: "".concat(input, "__extra"),
      help: "".concat(input, "__help"),
      success: "".concat(is, "-success"),
      successBorder: "".concat(form, "--success-border"),
      error: "".concat(is, "-error"),
      warning: "".concat(is, "-warning")
    };
  });
};
var ValidateStatus = /* @__PURE__ */function (ValidateStatus2) {
  ValidateStatus2["TO_BE_VALIDATED"] = "not";
  ValidateStatus2["SUCCESS"] = "success";
  ValidateStatus2["FAIL"] = "fail";
  return ValidateStatus2;
}(ValidateStatus || {});
var FormInjectionKey = Symbol("FormProvide");
var FormItemInjectionKey = Symbol("FormItemProvide");

export { FORM_CONTROL_COMPONENTS, FormInjectionKey, FormItemInjectionKey, ValidateStatus, useCLASSNAMES };
//# sourceMappingURL=const.mjs.map
